import DialogTitle from '@mui/material/DialogTitle';
import type { DialogTitleProps } from '@mui/material/DialogTitle';

const MUIDialogTitle = (props: DialogTitleProps) => {
  return (
    <DialogTitle
      data-testid="mui-dialog-title"
      sx={{
        fontSize: '1.5rem',
        gap: '8px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
      {...props}
    />
  );
};

export default MUIDialogTitle;
